import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    minWidth: 560,
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.colors.modal__background_primary,
    padding: theme.spacing(5)
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10
  },
  title: {
    color: theme.colorPalette.green_10,
    fontSize: 36,
    fontWeight: 300,
    padding: 0
  },
  text: {
    color: theme.colors.green_15,
    marginTop: 0,
    marginBottom: theme.spacing(4)
  },
  carInfo: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
    fontSize: 16
  },
  footer: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  },
  button: {
    fontSize: 16,
    width: 160
  },
  checkbox: {
    marginBottom: theme.spacing(5)
  }
});

export default makeStyles(styles);
